import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { dataStatModules } from "../../utils/constant";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { modalStyle } from "../../Components/Modal/Index";
import { Slide, toast } from "react-toastify";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  IconButton,
  Modal,
  Box,
  Autocomplete,
  Grid,
} from "@mui/material";
import "../../style/setup.css";
import { ImportModalSetup } from "../../Components/Fragments/Modals/ModalSetupStoreImport";
import { exportproductmastersetup } from "../../services/productMasterService";

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

const BootstrapButton = styled(Button)({
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  borderRadius: "4px",
  color: "#fff",
  fontSize: { xs: "14px", sm: "16px" },
  padding: "4px 10px",
  textTransform: "none",
  "&:hover": {
    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
  },
});

function SetupSuperBrand() {
  const accessToken = Cookies.get("access_token") || "";

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageList = [5, 10, 50, 100];
  const [totalItems, setTotalItems] = useState("");

  const [dataBrands, setDataBrands] = useState([]);
  const [dataCategories, setDataCategories] = useState([]);
  const [dataProfile, setDataProfile] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchBarValue, setSearchBarValue] = useState("setup-super-brand");
  const [selectedBrandForCategory, setSelectedBrandForCategory] = useState("");
  const [modalAddSetup, setModalAddSetup] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [editDataId, setEditDataId] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteDataId, setDeleteDataId] = useState(null);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [openDialogImport, setOpenDialogImport] = useState(false);
  const [excelFile, setExcelFile] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  const [newData, setNewData] = useState({
    namasuperbrand: "",
    namabrand: "",
    namagroup: "",
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
        "TL",
        "COA",
        "A",
      ]);
      fetchBrand();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchCategory();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedBrandForCategory]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchMainData();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken, currentPage, itemsPerPage]);

  async function fetchBrand() {
    const token = Cookies.get("access_token");

    setDataBrands([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/brand-category-master` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.brand_master,
          value: item.brand_master,
          value_for_category: item.brand_master_id,
        }));
        setDataBrands(newArray);
      } else {
        setDataBrands([]);
      }
    } catch (error) {
      setDataBrands([]);
    }
    setIsLoading(false);
  }

  async function fetchCategory() {
    if (selectedBrandForCategory) {
      const token = Cookies.get("access_token");

      setDataCategories([]);
      setIsLoading(true);

      const queryParams = new URLSearchParams();

      queryParams.append("brand_master_id", selectedBrandForCategory);

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/brand-category-master` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.category_master,
            value: item.category_master,
          }));
          setDataCategories(newArray);
        } else {
          setDataCategories([]);
        }
      } catch (error) {
        setDataCategories([]);
      }
      setIsLoading(false);
    }
  }

  async function fetchMainData() {
    const token = Cookies.get("access_token");

    setFilteredRows([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    queryParams.append("page", currentPage);
    queryParams.append("size", itemsPerPage);

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/stat/super/brand` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTotalItems(data.pagination_info.total);
        setFilteredRows(data.data);
      } else {
        setFilteredRows([]);
      }
    } catch (error) {
      setFilteredRows([]);
    }

    setIsLoading(false);
  }

  const handleTableSelection = (newValue) => {
    if (newValue) {
      setSearchBarValue(newValue.value);
      setTimeout(() => {
        window.location.href = newValue.value;
      }, 100);
    }
  };

  const handleSetupInputChange = (event) => {
    const { name, value } = event.target;
    setNewData({
      ...newData,
      [name]: value,
    });
  };

  const handleCreateData = async () => {
    const token = Cookies.get("access_token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/stat/super/brand`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newData),
        }
      );

      if (response.status === 201) {
        toast.success("Data berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setModalAddSetup(false);
        setCurrentPage(1);
        await fetchMainData();
      } else if (
        response.status == 400 ||
        response.status == 403 ||
        response.status == 404
      ) {
        const data = await response.json();
        toast.error(data.detail || "Data gagal dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status == 422) {
        toast.error("Data gagal diproses!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Data gagal dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating Data:", error);
    }
  };

  const handleAddNewSetup = () => {
    setModalAddSetup(true);
  };

  const handleEditClick = async (row) => {
    setEditedData({
      namasuperbrand: row.namasuperbrand,
      namagroup: row.namagroup,
      namabrand: row.namabrand,
    });
    const valueForCategory = dataBrands.find(
      (option) => option.value === row.namabrand
    );
    setSelectedBrandForCategory(
      valueForCategory?.value_for_category || ""
    );
    setEditDataId(row.id);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditedData({});
    setEditDataId(null);
    setDataCategories([]);
    setEditModalOpen(false);
  };

  const handleUpdateData = async () => {
    setIsLoading(true);
    if (editDataId) {
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/stat/super/brand/${editDataId}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedData),
          }
        );

        if (response.status === 200) {
          toast.success("Data berhasil diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          setEditModalOpen(false);
          setCurrentPage(1);
          await fetchMainData();
        } else if (
          response.status == 400 ||
          response.status == 403 ||
          response.status == 404
        ) {
          const data = await response.json();
          toast.error(data.detail || "Data gagal diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else if (response.status == 422) {
          toast.error("Data gagal diproses!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Data gagal diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const handleDeleteClick = async (row) => {
    setDeleteDataId(row.id);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleDeleteData = async () => {
    setIsLoading(true);
    if (deleteDataId) {
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/stat/cell/adjfactor/${deleteDataId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          toast.success("Data berhasil dihapus!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          setDeleteModalOpen(false);
          setCurrentPage(1);
          await fetchMainData();
        } else if (
          response.status == 400 ||
          response.status == 403 ||
          response.status == 404
        ) {
          const data = await response.json();
          toast.error(data.detail || "Data gagal dihapus!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Data gagal dihapus!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  async function fetchExportData() {
    const token = Cookies.get("access_token");
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    // if (selectedStoreType && selectedStoreType !== 'all') {
    //     queryParams.append('store_type', selectedStoreType);
    // }

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/stat/super/brand/export` +
      (queryString ? `?${queryString}` : "");
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Result Super Brand.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else if (response.status === 404) {
        toast.error("data not found");
      } else {
        toast.error("something went wrong went export data");
      }
    } catch (error) {
      // Handle error
    }

    setIsLoading(false);
  }

  const handleExportData = async () => {
    setCurrentPage(1);
    await fetchMainData("");

    fetchExportData(accessToken, setIsLoading);
  };

  // pagination
  const handlePageChange = (event, page) => {
    setCurrentPage(page + 1);
  };

  const handleChangeItemPerPageSelect = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  // import modal
  const refreshData = () => {
    fetchMainData();
  };

  const handleImportData = () => {
    setOpenDialogImport(true);
  };

  const handleCloseDialog = () => {
    setOpenDialogImport(false);
    setExcelFile("");
    setFileUrl("");
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await importDataTemplate();
    setIsLoading(false);
  };

  async function importDataTemplate() {
    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/stat/super/brand/import/template`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      if (response.status === 201) {
        toast.success("Upload Super Brand berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setOpenDialogImport(false);
        //refresh
        setCurrentPage(1);
        refreshData();
      } else if (response.status === 200) {
        // throw data as blob then download it when validation on excel got fail
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Super Brand Error.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        toast.error("Ada masalah di excel. Periksa kembali isi excel!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("Gagal mengimport Super Brand Setup!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error(
          "Failed to import Super Brand template:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error importing Super Brand template:", error);
    }
  }

  async function exportDataTemplate() {
    setIsLoading(true);
    const blob = await exportproductmastersetup(
      accessToken,
      "template",
      "api/v1/stat/super/brand/export/template",
      {}
    );
    if (blob) {
      // throw data as blob then download it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Template Super Brand.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      toast.error("Gagal mendownload template Super Brand!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  }

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Stat Module"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Stat Module"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <Grid container spacing={0.5}>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataStatModules}
                getOptionLabel={(option) => option.label}
                value={
                  dataStatModules.find(
                    (option) => option.value === searchBarValue
                  ) || null
                }
                onChange={(e, newValue) => handleTableSelection(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cari Kategori"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                disableClearable
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleAddNewSetup}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Add"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleImportData}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Upload"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleExportData}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Download"}
              </BootstrapButton>
            </Grid>
          </Grid>
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 650 }}>
            <Table
              aria-label="simple table"
              sx={{
                border: 1,
                borderColor: "grey.300",
                borderCollapse: "collapse",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Super Brand</TableCell>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Brand</TableCell>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Category</TableCell>
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Aksi</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length > 0 ? (
                  filteredRows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.namasuperbrand}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.namabrand}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.namagroup}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                        <Tooltip
                          title="Edit Data"
                          onClick={() => handleEditClick(row)}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        {/* <Tooltip
                          title="Delete Data"
                          onClick={() => handleDeleteClick(row)}
                        >
                          <IconButton>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip> */}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                      {isLoading ? "Loading..." : "No Data Available"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* pagination */}
          {filteredRows.length > 0 && (
            <TablePagination
              rowsPerPageOptions={itemsPerPageList}
              component="div"
              count={totalItems}
              rowsPerPage={itemsPerPage}
              page={currentPage - 1}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeItemPerPageSelect}
            />
          )}
        </Paper>

        <Modal
          open={modalAddSetup}
          onClose={() => setModalAddSetup(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <Tooltip title="Close Modal">
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => {
                  setModalAddSetup(false);
                  setNewData({
                    namasuperbrand: "",
                    namabrand: "",
                    namagroup: "",
                  });
                  setDataCategories([]);
                }}
                sx={{ position: "absolute", top: 20, right: 30 }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <div className="create-data">
              <h2 style={{ marginBottom: "15px" }}>Create Super Brand</h2>
              <div>
                <TextField
                  label="SUPER BRAND"
                  name="namasuperbrand"
                  value={newData.namasuperbrand}
                  onChange={handleSetupInputChange}
                  sx={{ width: "100%", mb: 2 }}
                />
              </div>
              <div>
                <Autocomplete
                  options={dataBrands}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataBrands.find(
                      (option) => option.value === newData.namabrand
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "namabrand",
                        value: newValue ? newValue.value : "",
                      },
                    });

                    setSelectedBrandForCategory(
                      newValue ? newValue.value_for_category : ""
                    );
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="BRAND" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>
              <div>
                <Autocomplete
                  options={dataCategories}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataCategories.find(
                      (option) => option.value === newData.namagroup
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "namagroup",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="CATEGORY" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>
              <div>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "100%", mt: 2, height: 50, mb: 3 }}
                  onClick={handleCreateData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Submit"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={editModalOpen}
          onClose={handleCloseEditModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={modalStyle}
            style={{
              maxHeight: "400px",
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            <div className="edit-data">
              <h2>Edit Super Brand</h2>
              <div>
                <TextField
                  name="namasuperbrand"
                  label="Super Category"
                  sx={{ width: "100%", mb: 2 }}
                  value={editedData.namasuperbrand ?? ""}
                  onChange={(e) =>
                    setEditedData({
                      ...editedData,
                      namasuperbrand: e.target.value,
                    })
                  }
                />
                <Autocomplete
                  options={dataBrands}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataBrands.find(
                      (option) => option.value === editedData.namabrand
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedData({
                      ...editedData,
                      namabrand: newValue ? newValue.value : "",
                    });
                    
                    setSelectedBrandForCategory(
                      newValue ? newValue.value_for_category : ""
                    );
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="BRAND" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
                <Autocomplete
                  options={dataCategories}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataCategories.find(
                      (option) => option.value === editedData.namagroup
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedData({
                      ...editedData,
                      namagroup: newValue ? newValue.value : "",
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="CATEGORY" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  sx={{
                    width: "50%",
                    height: 50,
                    mt: 2,
                    color: "#b34469",
                    borderColor: "#b34469",
                  }}
                  onClick={handleCloseEditModal}
                >
                  Cancel
                </Button>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                  onClick={handleUpdateData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "UPDATE"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={deleteModalOpen}
          onClose={handleCloseDeleteModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={modalStyle}
            style={{
              maxHeight: "400px",
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            <div className="delete-data">
              <h2>Hapus Data</h2>
              <p>Apakah anda yakin untuk menghapus data ini?</p>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  sx={{
                    width: "50%",
                    height: 50,
                    mt: 2,
                    color: "#b34469",
                    borderColor: "#b34469",
                  }}
                  onClick={handleCloseDeleteModal}
                >
                  Tidak
                </Button>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                  onClick={handleDeleteData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Ya"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <ImportModalSetup
          isLoading={isLoading}
          open={openDialogImport}
          onClose={handleCloseDialog}
          title={"Import Super Brand"}
          buttonTitle={"Upload"}
          fileUrl={fileUrl}
          handleSubmit={handleUpload}
          handleChange={{
            excel: setExcelFile,
            fileUrl: setFileUrl,
          }}
          handleExport={{
            template: exportDataTemplate,
          }}
        />
      </div>
    </div>
  );
}

export default SetupSuperBrand;
